import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import ExternalLinkWrapper from '../../../navigation/ExternalLinkWrapper';
import './cklaTable.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const CKLATableHeaders = ['Introduce', 'Review & Practice', 'Reteach & Remediate'];

const CKLATable = ({ widgetData }) => (
    <div className="ckla-table-wrap">
        {widgetData.map((column, index) => (
            <p className="ckla-table-row" key={generateReactKey(index)}>
                <span className="ckla-table-cell ckla-table-header-cell">
                    {CKLATableHeaders[index]}
                </span>
                <span className="ckla-table-column">
                    {column.map(({ link, text }, columnIndex) => (
                        <span className="ckla-table-cell" key={generateReactKey(columnIndex)}>
                            {!isEmpty(link) ? (
                                <ExternalLinkWrapper
                                    className="ckla-inst-link"
                                    content={text}
                                    path={link}
                                />
                            ) : (
                                <span className="ckla-inst-link">{text}</span>
                            )}
                        </span>
                    ))}
                </span>
            </p>
        ))}
    </div>
);

CKLATable.defaultProps = {
    widgetData: [],
};

CKLATable.propTypes = {
    widgetData: PropTypes.array,
};

export default CKLATable;
